import { Stack } from '@fluentui/react';
import { Button, FluentProvider, Spinner, webLightTheme } from '@fluentui/react-components';
import React from 'react';
import { EmptyLayout } from '../../../layout/EmptyLayout/EmptyLayout';
import { useUnsubscribe } from './hooks/useUnsubscribe';
import { decryptCSharpAes } from './utils/Decryption';

const safeUrlDecode = (url: string) => {
  try {
    return decodeURIComponent(url);
  } catch (error) {
    console.error('Error decoding URL:', error);
    return '';
  }
};

export const ReportUnsubscribePage = () => {
  const encryptedContext = new URLSearchParams(window.location.search).get('context');
  const encryptedData = new URLSearchParams(window.location.search).get('data');
  const decodedContext = safeUrlDecode(encryptedContext || '');
  const decodedData = safeUrlDecode(encryptedData || '');

  const decryptedValue = decryptCSharpAes(
    decodedContext,
    process.env.REACT_APP_DECRYPTION_PASSWORD ?? '',
    process.env.REACT_APP_DECRYPTION_SALT ?? '',
    parseInt(process.env.REACT_APP_DECRYPTION_ITERATIONS ?? '0', 10),
    parseInt(process.env.REACT_APP_DECRYPTION_SIZE ?? '0', 10),
    process.env.REACT_APP_DECRYPTION_INITIALIZER ?? ''
  );

  const reportId = decryptedValue?.ReportId ?? '';
  const userEmail = decodedData.split('|')[2] || '';

  const { mutate: unsubscribe, isLoading, isSuccess, isError } = useUnsubscribe();

  return (
    <EmptyLayout>
      <FluentProvider theme={webLightTheme}>
        {reportId === '' || userEmail === '' ? (
          <Stack style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center' }} gap={20}>
            <h2>Invalid or missing unsubscribe link.</h2>
          </Stack>
        ) : (
          <Stack style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center' }} gap={20}>
            <h2>Are You Sure You want to Unsubscribe From Email Notifications ?</h2>
            {!isSuccess && !isError && (
              <Button
                appearance="primary"
                onClick={() => unsubscribe({ reportId, email: userEmail })}
                disabled={!reportId || reportId === '' || isLoading}
              >
                {isLoading ? <Spinner label={<span>Unsubscribing...</span>} /> : 'Unsubscribe'}
              </Button>
            )}
            {isSuccess && <h3 style={{ color: 'green' }}>You have been unsubscribed successfully.</h3>}
            {isError && <h3 style={{ color: 'red' }}>Failed to unsubscribe. Please try again later.</h3>}
          </Stack>
        )}
      </FluentProvider>
    </EmptyLayout>
  );
};
